import { render } from "./RntrcFaturamento.vue?vue&type=template&id=35027d66&scoped=true"
import script from "./RntrcFaturamento.vue?vue&type=script&lang=ts"
export * from "./RntrcFaturamento.vue?vue&type=script&lang=ts"

import "./RntrcFaturamento.vue?vue&type=style&index=0&id=35027d66&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-35027d66"

export default script